<div *ngIf="show()" class="toast-container">
  <tds-toast (tdsClose)="hide()" [header]="toast()?.header" [subheader]="toast()?.subheader" [variant]="toast()?.variant || 'information'">
    <div slot="subheader">
      {{ toast()?.message }}
    </div>
  </tds-toast>
</div>